import { Input } from 'antd';
import React, { ReactElement } from 'react';

interface IControlPanelInput {
    icon?: ReactElement;
    title?: string;
}

const ControlPanelInput: React.FC<IControlPanelInput> = ({ icon, title }) => {
    return <Input placeholder={title} prefix={icon} size="middle" allowClear style={{ width: 300 }} />;
};

export default ControlPanelInput;
